import * as React from 'react';
export default function ToolBar(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "tool-bar",
    style: props.style
  }, props.children);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-markdown-editor-lite/esm/components/ToolBar/index.js
// module id = 1466
// module chunks = 0